'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_display_Table_TableTd = require('./TableTd.cjs.js');

const TableTh = ({ children, className, freeze, headers, id, scope, shadowed, role = "columnheader" }) => {
  return react.jsx("th", { css: [components_display_Table_TableTd.Styles.root, className], "data-freeze": freeze, "data-shadowed": shadowed, "data-zds": true, headers, id, role, scope }, children);
};

exports.TableTh = TableTh;
//# sourceMappingURL=TableTh.cjs.js.map
